import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { Redirect } from "../auth/redirect";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";
import { DepartmanEkle_Screen } from "../screens/departmanekle/departmanekle";
import { TicketOlusturma_Screen } from "../screens/ticketolusturma/ticketolusturma";
import { KullaniciListesi_Screen } from "../screens/kullanicilistesi/kullanicilistesi";
import { ForgotPassword_Screen } from "../screens/forgotpassword/forgotpassword";
import { ResetPassword_Screen } from "../screens/resetpassword/resetpassword";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { HomePage_Screen } from "../screens/homepage/homepage";
import { DeleteMusteri_Screen } from "../screens/deletemusteri/deletemusteri";
import { Marketing_Dashboard_With_Left_Menu_Screen } from "../screens/marketing_dashboard_with_left_menu/marketing_dashboard_with_left_menu";
import { MusteriKayit_Screen } from "../screens/musterikayit/musterikayit";
import { Signin_Screen } from "../screens/signin/signin";
import { DeleteDepartman_Screen } from "../screens/deletedepartman/deletedepartman";
import { TicketListesi_Screen } from "../screens/ticketlistesi/ticketlistesi";
import { DeleteTicket_Screen } from "../screens/deleteticket/deleteticket";
import { KullaniciBilgisi_Screen } from "../screens/kullanicibilgisi/kullanicibilgisi";
import { SistemLoglari_Screen } from "../screens/sistemloglari/sistemloglari";
import { DeleteKullanici_Screen } from "../screens/deletekullanici/deletekullanici";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { TicketDetay_Screen } from "../screens/ticketdetay/ticketdetay";
import { MusteriListesi_Screen } from "../screens/musterilistesi/musterilistesi";
import { Sales_Dashboard_With_Left_Menu_Screen } from "../screens/sales_dashboard_with_left_menu/sales_dashboard_with_left_menu";
import { Deneme_Screen } from "../screens/deneme/deneme";
import { KullaniciEkle_Screen } from "../screens/kullaniciekle/kullaniciekle";
import { MasterEkran_Screen } from "../screens/masterekran/masterekran";
import { Signup_Screen } from "../screens/signup/signup";
import { TicketDuzenle_Screen } from "../screens/ticketduzenle/ticketduzenle";



import { IAppMode, IAuthType } from "../bootstrapper";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import { KMainFunctions } from "../shared/utilty/main-functions";

const confJson = require("../shared/json/conf.json");

interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
            <PrivateRoute exact path="/" component={HomePage_Screen} />
                        <PrivateRoute exact path="/departmanekle" component={DepartmanEkle_Screen} />
            <PrivateRoute exact path="/ticketolusturma" component={TicketOlusturma_Screen} />
            <PrivateRoute exact path="/kullanicilistesi" component={KullaniciListesi_Screen} />
            <PrivateRoute exact path="/forgotpassword" component={ForgotPassword_Screen} />
            <Route exact path="/resetpassword" component={ResetPassword_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <PrivateRoute exact path="/homepage" component={HomePage_Screen} />
            <PrivateRoute exact path="/deletemusteri" component={DeleteMusteri_Screen} />
            <PrivateRoute exact path="/marketing_dashboard_with_left_menu" component={Marketing_Dashboard_With_Left_Menu_Screen} />
            <PrivateRoute exact path="/musterikayit" component={MusteriKayit_Screen} />
            <Route exact path="/signin" component={this.LoginComponent()} />
            <PrivateRoute exact path="/deletedepartman" component={DeleteDepartman_Screen} />
            <PrivateRoute exact path="/ticketlistesi" component={TicketListesi_Screen} />
            <PrivateRoute exact path="/deleteticket" component={DeleteTicket_Screen} />
            <PrivateRoute exact path="/kullanicibilgisi" component={KullaniciBilgisi_Screen} />
            <PrivateRoute exact path="/sistemloglari" component={SistemLoglari_Screen} />
            <PrivateRoute exact path="/deletekullanici" component={DeleteKullanici_Screen} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <PrivateRoute exact path="/ticketdetay" component={TicketDetay_Screen} />
            <PrivateRoute exact path="/musterilistesi" component={MusteriListesi_Screen} />
            <PrivateRoute exact path="/sales_dashboard_with_left_menu" component={Sales_Dashboard_With_Left_Menu_Screen} />
            <PrivateRoute exact path="/deneme" component={Deneme_Screen} />
            <PrivateRoute exact path="/kullaniciekle" component={KullaniciEkle_Screen} />
            <Route exact path="/signup" component={Signup_Screen} />
            <PrivateRoute exact path="/ticketduzenle" component={TicketDuzenle_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    if (isWebComponentApp === true || this.props.routerType === "HashRouter") {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    if (
      external_access_token !== null &&
      external_access_token !== undefined &&
      external_access_token !== "" &&
      external_refresh_token !== null &&
      external_refresh_token !== undefined &&
      external_refresh_token !== ""
    ) {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Signin_Screen;
    }
    return <></>;
  };
}
